export const CopilotSandbox = () => {
  return <div>CopilotSandbox</div>
}
